<template>
  <div class="grading-effect">
    <md-field>
      <md-input 
        placeholder="Name" 
        :value="state.effect.label" 
        class="name-input"
        @input="value => updateLabel(value)" 
      />
    </md-field>
    <grading-item
      label
      :grade="state.effect.grade"
      :points="state.effect.points"
      :is-critical="state.effect.isCritical"
      :readonly="readonly"
      :disable-neutral="true"
      @changeGrade="value => updateGrade(value)"
      @changePoints="value => updatePoints(value)"
      @changeIsCritical="value => updateIsCritical(value)"
      @pointsDragStart="disableNodeDrag"
      @pointsDragEnd="enableNodeDrag"
    />
  </div>
</template>

<script>
import GradingItem from '~lib/common/components/GradingItem';

export default {
  name: 'end-condition-effect',
  components: {
    GradingItem,
  },
  props: ['readonly', 'emitter', 'ikey', 'getData', 'putData', 'control'],
  data() {
    return {
      state: {
        effect: {
          label: '',
          grade: 'GOOD',
          points: 0,
          isCritical: false,
        },
      },
      value: 0,
    };
  },
  computed: {},
  mounted() {
    this.state.effect = this.getData(this.ikey) || {
      label: '',
      grade: 'GOOD',
      points: 0,
      isCritical: false,
    };
    this.update();
  },
  methods: {
    disableNodeDrag() {
      this.emitter.trigger('disableNodeDrag', this.control.parent);
    },
    enableNodeDrag() {
      this.emitter.trigger('enableNodeDrag', this.control.parent);
    },
    updateLabel(label) {
      this.state.effect.label = label;
      this.update();
    },
    updateGrade(grade) {
      this.state.effect.grade = grade;
      this.update();
    },
    updatePoints(points) {
      this.state.effect.points = points;
      this.update();
    },
    updateIsCritical(isCritical) {
      this.state.effect.isCritical = isCritical;
      this.update();
    },
    update() {
      this.putData(this.ikey, {
        type: 'GRADING',
        label: this.state.effect.label,
        grade: this.state.effect.grade,
        points: this.state.effect.points,
        isCritical: this.state.effect.isCritical,
      });
      this.emitter.trigger('process', this.control);
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped>
.grading-effect {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
